
import { GlobalResponseObject } from '../../global-response-object';
import { CreateUserDto } from './user-dto';
export class AllUserResponseModel extends GlobalResponseObject {
    data?: CreateUserDto[];

    /**
     * 
     * @param status 
     * @param intlCode 
     * @param internalMessage 
     * @param data 
     */

    constructor(status:boolean, intlCode: number, internalMessage:string, data?:CreateUserDto[]){
        super(status, intlCode, internalMessage)
        this.data = data
    }
}
